var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomepageLayoutInActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 8.33334L9.25629 2.34153C9.46804 2.1743 9.73004 2.08334 9.99996 2.08334C10.2699 2.08334 10.5319 2.1743 10.7436 2.34153L13.75 4.71492V3.33334C13.75 2.87311 14.123 2.50001 14.5833 2.50001H15.4166C15.8769 2.50001 16.25 2.8731 16.25 3.33334V6.68861L18.3333 8.33334",
    stroke: "#A8A8A8",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 9.58334V12.9167C16.6667 15.2737 16.6667 16.4522 15.9345 17.1844C15.2022 17.9167 14.0237 17.9167 11.6667 17.9167H8.33337C5.97635 17.9167 4.79784 17.9167 4.06561 17.1844C3.33337 16.4522 3.33337 15.2737 3.33337 12.9167V9.58334",
    stroke: "#A8A8A8",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.501 12.9167C11.8347 13.4353 10.9595 13.75 10.001 13.75C9.04248 13.75 8.16724 13.4353 7.50098 12.9167",
    stroke: "#A8A8A8",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepageLayoutInActive);
export default __webpack_public_path__ + "static/media/HomepageLayoutInActive.73cbda6c85b5d756dfe72b011a6892cf.svg";
export { ForwardRef as ReactComponent };